import Vue from "vue";

export default Vue.extend({
  template: `
    <input 
      type="checkbox" 
      @click="checkedHandler($event)"
      :checked="params.value"
    />
`,
  methods: {
    checkedHandler(event) {
      let checked = event.target.checked;
      let colId = this.params.column.colId;
      this.params.node.setDataValue(colId, checked);
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/gt/shared/ag-grid/AgCellBooleanEditor.js